import type { AppSettings } from "@nmt/shared";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { get, patch } from "../../api";

export interface SettingsResponse {
  settings: AppSettings;
  logoUrl: string | null;
  leadFormUrl: string | null;
}

export function useSettings() {
  const qc = useQueryClient();
  const query = useQuery({ queryKey: ["settings"], queryFn: () => get<SettingsResponse>("/api/settings") });
  const save = useMutation({
    mutationFn: (changes: Partial<AppSettings>) => patch<SettingsResponse>("/api/settings", changes),
    onSuccess: async (data) => {
      qc.setQueryData(["settings"], data);
      // Theme, company name, and lists are part of /api/me.
      await qc.invalidateQueries({ queryKey: ["me"] });
    },
  });
  return { query, save };
}
